import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"thumb-up-1"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M19.4609 19.3041L20.6455 11.6041C20.8319 10.3926 19.8945 9.3 18.6688 9.3H13.8V5.84605C13.8 4.68389 13.0563 3.65211 11.9538 3.28461L11.1 3L7.5 11.1H4V21H17.4842C18.4713 21 19.3108 20.2798 19.4609 19.3041Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M19.4609 19.3041L20.6455 11.6041C20.8319 10.3926 19.8945 9.3 18.6688 9.3H13.8V5.84605C13.8 4.68389 13.0563 3.65211 11.9538 3.28461L11.1 3L7.5 11.1H4V21H17.4842C18.4713 21 19.3108 20.2798 19.4609 19.3041Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ThumbUp1 = Vue.extend<IconProps>({
  name: 'ThumbUp1Icon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'thumb-up-1',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default ThumbUp1;
